module.exports = __webpack_public_path__ + "media/icons/tapicerka-skorzana-unactive@2x-d1f5ae33.png";